import { useMutation, useQueryClient } from '@tanstack/react-query';
import { allocationQueries } from '../queries';
import { allocationService } from '../services/allocationService';
import type { Allocation } from '../types/Allocation';

export type CloseAllocationVariables = { id: number; endDate: string | null };

export function useCloseAllocation() {
  const qc = useQueryClient();
  return useMutation<Allocation, unknown, CloseAllocationVariables>({
    mutationFn: ({ id, endDate }) => allocationService.close(id, endDate),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: allocationQueries.lists() });
      qc.invalidateQueries({ queryKey: allocationQueries.timelines() });
      qc.invalidateQueries({ queryKey: allocationQueries.checks() });
    },
  });
}
